export const name = 'reducedMotion' as const
